// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-select-plan #content {
  max-width: 100%;
}

@media screen and (orientation: landscape) {
  .container-select-plan #content {
    max-width: var(--content-max-width);
  }
}

.header-page-select-plan .logo-container{
  justify-content: center;
}

.page-select-plan {
  padding-bottom: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-select-plan .page-title {
  width: 100%;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
  margin: 0;
}

/* tablet */
@media (max-width: 768px) {
  .page-select-plan .page-title {
    padding-left: var(--page-side-padding-768);
    padding-right: var(--page-side-padding-768);
    width: calc(100% + var(--page-side-padding-768) * 2);
  }
}

.page-select-plan .page-title span {
  color: var(--orange);
}

.page-select-plan .description-container {
  margin: 12px 27px 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 130%;
  text-align: center;
}

.page-select-plan .progress-container {
  background-color: var(--pink);
}

.page-select-plan .progress-container .title-progress-container {
  padding: 24px 0;
  display: flex;
  justify-content: space-around;
  background-color: var(--pink);
}

.page-select-plan .progress-container .title-progress-container :is(.now, .goal) {
  padding: 6px 14px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.8px;
  background-color: var(--orange);
  color: var(--white);
}

.page-select-plan .progress-container .title-progress-container .now {
  background-color: var(--white);
  color: var(--orange);
}

.page-select-plan .progress-container img {
  width: 100%;
}

.page-select-plan .progress-description-container {
  background-color: var(--white);
  border-radius: 0 0 16px 16px;
  width: 100%;
  padding: 24px 24px 0;
  display: flex;
  justify-content: space-between;
}

.page-select-plan .guarantee-container {
  margin-top: 14px;
}

.page-select-plan :is(.select-plan-block, .select-plan-block-v2) {
  width: 100%;
  padding-top: 40px;
}

.page-select-plan :is(.select-plan-block, .select-plan-block-v2) .before-plan-subscription {
  margin: 24px auto 12px;
}

.page-select-plan .advantages-container {
  margin: 40px 0;
}

.page-select-plan .advantages-container .main-title {
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;
  text-align: center;
}

.page-select-plan .advantages-container .item + .item {
  margin-top: 13px;
}

.page-select-plan .advantages-container .item {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.page-select-plan .advantages-container .item img {
  width: 24px;
}

.page-select-plan .advantages-container .item .text {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  text-align: left;
}

.page-select-plan .bonus-section {
  width: 100%;
}

.page-select-plan .bonus-container {
  padding: 20px;
  margin-top: 24px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  border-radius: 16px;
  background-color: var(--white);
  box-shadow: 4px 6px 12px 0 rgba(24, 28, 39, 0.04);
}

.page-select-plan .bonus-container .item {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.page-select-plan .bonus-container .item:nth-child(2) {
  height: 1px;
  background-color: var(--gray);
}

.page-select-plan .bonus-container .item img {
  width: 52px;
}

.page-select-plan .bonus-container .item .text {
  color: var(--orange);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  text-transform: uppercase;
}

.page-select-plan .bonus-container .item .description {
  color: var(--black);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
}

.page-select-plan .trophy-container {
  margin-top: 12px;
  padding: 20px;
  background-color: var(--white);
  border-radius: 16px;
  box-shadow: 4px 6px 12px 0 rgba(24, 28, 39, 0.04);
}

.page-select-plan .trophy-container .item {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.page-select-plan .trophy-container .item img {
  width:63px;
}

.page-select-plan .trophy-container .item .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.page-select-plan .trophy-container .item .text span {
  font-weight: 700;
}

.page-select-plan .title-reviews {
  margin: 40px auto 24px;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  text-align: center;
}

.page-select-plan .company-contacts-container  {
  margin: 8px auto 0;
  color: var(--dark-gray);
}

.page-select-plan .policy-container {
  margin: 16px auto 0;
}


.page-select-plan .faq {
  margin-top: 40px;
  background-color: var(--light-pink);
}

.page-select-plan .faq > .title {
  margin-top: 24px;
  font-size: 28px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: center;
}

.page-select-plan .faq > .questions-list {
  padding: 24px;
}

.page-select-plan .faq .accordion + .accordion {
  margin-top: 16px;
}

.page-select-plan .button-container.prime .btn {
  height: 49px;
  opacity: 1;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  animation: shadowAnimation 3s infinite;
}

@keyframes shadowAnimation {
  0%, 100% {
    box-shadow: rgba(255, 127, 107, 0.3) 0 0 0 0, rgba(255, 127, 107, 0.3) 0 0 0 0;
  }
  18% {
    box-shadow: rgba(255, 127, 107, 0.3) 0 0 0 0, rgba(255, 127, 107, 0.3) 0 0 0 0;
  }
  100% {
    box-shadow: transparent 0 0 0 16px, transparent 0 0 0 27px;
  }
}

.page-select-plan .review-block {
  background-color: var(--light-pink);
  margin-top: 40px;
}

.page-select-plan .review-block .item-reviews {
  margin: 16px 24px;
  box-shadow: 0 4px 8px 0 var(--light-gray);
  padding: 16px;
  background-color: white;
  border-radius: 20px;
}

.page-select-plan .review-block .item-reviews:last-child {
  margin-bottom: 24px;
}

.page-select-plan .review-block .review-title {
  margin: 24px 0;
  color: var(--black);
  font-size: 28px;
  font-weight: 600;
  line-height: 33.6px;
  text-align: center;
}

.page-select-plan .review-block .star-container {
  display: flex;
  gap: 2px;
}

.page-select-plan .review-block .star-container svg {
  height: 16px;
  width: 16px;
}

.page-select-plan .review-block .body-text {
  margin: 12px 0;
  color: black;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
}

.page-select-plan .review-block .user-name {
  color: var(--black);
  font-size: 16px;
  font-weight: 700;
  line-height: 19.2px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/select-plan.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA,WAAW;AACX;EACE;IACE,0CAA0C;IAC1C,2CAA2C;IAC3C,oDAAoD;EACtD;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,0DAA0D;EAC1D,sCAAsC;AACxC;;AAEA;EACE;IACE,8EAA8E;EAChF;EACA;IACE,8EAA8E;EAChF;EACA;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".container-select-plan #content {\n  max-width: 100%;\n}\n\n@media screen and (orientation: landscape) {\n  .container-select-plan #content {\n    max-width: var(--content-max-width);\n  }\n}\n\n.header-page-select-plan .logo-container{\n  justify-content: center;\n}\n\n.page-select-plan {\n  padding-bottom: 34px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-select-plan .page-title {\n  width: 100%;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 36px;\n  text-align: center;\n  margin: 0;\n}\n\n/* tablet */\n@media (max-width: 768px) {\n  .page-select-plan .page-title {\n    padding-left: var(--page-side-padding-768);\n    padding-right: var(--page-side-padding-768);\n    width: calc(100% + var(--page-side-padding-768) * 2);\n  }\n}\n\n.page-select-plan .page-title span {\n  color: var(--orange);\n}\n\n.page-select-plan .description-container {\n  margin: 12px 27px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 130%;\n  text-align: center;\n}\n\n.page-select-plan .progress-container {\n  background-color: var(--pink);\n}\n\n.page-select-plan .progress-container .title-progress-container {\n  padding: 24px 0;\n  display: flex;\n  justify-content: space-around;\n  background-color: var(--pink);\n}\n\n.page-select-plan .progress-container .title-progress-container :is(.now, .goal) {\n  padding: 6px 14px;\n  border-radius: 24px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20.8px;\n  background-color: var(--orange);\n  color: var(--white);\n}\n\n.page-select-plan .progress-container .title-progress-container .now {\n  background-color: var(--white);\n  color: var(--orange);\n}\n\n.page-select-plan .progress-container img {\n  width: 100%;\n}\n\n.page-select-plan .progress-description-container {\n  background-color: var(--white);\n  border-radius: 0 0 16px 16px;\n  width: 100%;\n  padding: 24px 24px 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.page-select-plan .guarantee-container {\n  margin-top: 14px;\n}\n\n.page-select-plan :is(.select-plan-block, .select-plan-block-v2) {\n  width: 100%;\n  padding-top: 40px;\n}\n\n.page-select-plan :is(.select-plan-block, .select-plan-block-v2) .before-plan-subscription {\n  margin: 24px auto 12px;\n}\n\n.page-select-plan .advantages-container {\n  margin: 40px 0;\n}\n\n.page-select-plan .advantages-container .main-title {\n  margin-bottom: 24px;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 120%;\n  text-align: center;\n}\n\n.page-select-plan .advantages-container .item + .item {\n  margin-top: 13px;\n}\n\n.page-select-plan .advantages-container .item {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.page-select-plan .advantages-container .item img {\n  width: 24px;\n}\n\n.page-select-plan .advantages-container .item .text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.8px;\n  text-align: left;\n}\n\n.page-select-plan .bonus-section {\n  width: 100%;\n}\n\n.page-select-plan .bonus-container {\n  padding: 20px;\n  margin-top: 24px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n\n  border-radius: 16px;\n  background-color: var(--white);\n  box-shadow: 4px 6px 12px 0 rgba(24, 28, 39, 0.04);\n}\n\n.page-select-plan .bonus-container .item {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.page-select-plan .bonus-container .item:nth-child(2) {\n  height: 1px;\n  background-color: var(--gray);\n}\n\n.page-select-plan .bonus-container .item img {\n  width: 52px;\n}\n\n.page-select-plan .bonus-container .item .text {\n  color: var(--orange);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 150%;\n  text-transform: uppercase;\n}\n\n.page-select-plan .bonus-container .item .description {\n  color: var(--black);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.page-select-plan .trophy-container {\n  margin-top: 12px;\n  padding: 20px;\n  background-color: var(--white);\n  border-radius: 16px;\n  box-shadow: 4px 6px 12px 0 rgba(24, 28, 39, 0.04);\n}\n\n.page-select-plan .trophy-container .item {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.page-select-plan .trophy-container .item img {\n  width:63px;\n}\n\n.page-select-plan .trophy-container .item .text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.page-select-plan .trophy-container .item .text span {\n  font-weight: 700;\n}\n\n.page-select-plan .title-reviews {\n  margin: 40px auto 24px;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  text-align: center;\n}\n\n.page-select-plan .company-contacts-container  {\n  margin: 8px auto 0;\n  color: var(--dark-gray);\n}\n\n.page-select-plan .policy-container {\n  margin: 16px auto 0;\n}\n\n\n.page-select-plan .faq {\n  margin-top: 40px;\n  background-color: var(--light-pink);\n}\n\n.page-select-plan .faq > .title {\n  margin-top: 24px;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 33.6px;\n  text-align: center;\n}\n\n.page-select-plan .faq > .questions-list {\n  padding: 24px;\n}\n\n.page-select-plan .faq .accordion + .accordion {\n  margin-top: 16px;\n}\n\n.page-select-plan .button-container.prime .btn {\n  height: 49px;\n  opacity: 1;\n  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  animation: shadowAnimation 3s infinite;\n}\n\n@keyframes shadowAnimation {\n  0%, 100% {\n    box-shadow: rgba(255, 127, 107, 0.3) 0 0 0 0, rgba(255, 127, 107, 0.3) 0 0 0 0;\n  }\n  18% {\n    box-shadow: rgba(255, 127, 107, 0.3) 0 0 0 0, rgba(255, 127, 107, 0.3) 0 0 0 0;\n  }\n  100% {\n    box-shadow: transparent 0 0 0 16px, transparent 0 0 0 27px;\n  }\n}\n\n.page-select-plan .review-block {\n  background-color: var(--light-pink);\n  margin-top: 40px;\n}\n\n.page-select-plan .review-block .item-reviews {\n  margin: 16px 24px;\n  box-shadow: 0 4px 8px 0 var(--light-gray);\n  padding: 16px;\n  background-color: white;\n  border-radius: 20px;\n}\n\n.page-select-plan .review-block .item-reviews:last-child {\n  margin-bottom: 24px;\n}\n\n.page-select-plan .review-block .review-title {\n  margin: 24px 0;\n  color: var(--black);\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 33.6px;\n  text-align: center;\n}\n\n.page-select-plan .review-block .star-container {\n  display: flex;\n  gap: 2px;\n}\n\n.page-select-plan .review-block .star-container svg {\n  height: 16px;\n  width: 16px;\n}\n\n.page-select-plan .review-block .body-text {\n  margin: 12px 0;\n  color: black;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.8px;\n}\n\n.page-select-plan .review-block .user-name {\n  color: var(--black);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19.2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
